import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Select, Store } from '@ngxs/store';
import {
    AccountActions,
    AccountSelectors,
    ModulesSelectors,
    SosLoaderService,
} from '@serviceos-ng/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

export interface AvatarForm {
    edit_button_title: string;
}

@Component({
    selector: 'serviceos-web-avatar-form',
    templateUrl: './avatar-form.component.html',
    styleUrls: ['./avatar-form.component.scss'],
})
export class AvatarFormComponent implements OnInit {
    @Select(AccountSelectors.avatar)
    public avatar!: Observable<string>;
    public showLoader = false;

    @Select(
        ModulesSelectors.getComponentFromModule(
            'account',
            'account_settings_screen.account_details.avatar'
        )
    )
    avatarForm$!: Observable<AvatarForm | null>;

    constructor(
        private router: Router,
        private store: Store,
        private sosLoaderService: SosLoaderService
    ) {}

    ngOnInit(): void {}

    onFileSelected(event) {
        if (event.target.files.length > 0) {
            this.showLoader = true;

            this.store
                .dispatch(new AccountActions.uploadFile(event.target.files[0]))
                .pipe(
                    finalize(() => {
                        this.showLoader = false;
                    })
                )
                .subscribe();
        }
    }

    /**
     * Navigate to path
     * @param {string} path
     */
    navigateTo(path: string) {
        this.router.navigateByUrl(path);
    }
}
